import { FeatureFlagsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { featureFlagsKeys } from 'app/queries/featureFlags/featureFlagsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof featureFlagsKeys.attorneyView>>;

export const createFetchAttorneyViewFeatureFlagsQueryFn =
  (call: TCall) =>
  async ({ signal }: TParams) =>
    (await call(() => cancelOnSignal(FeatureFlagsService.findAllForAttorneyView(), signal))) ?? [];
